@if (displayFieldSelector) {
  <app-dropdown-control
    [data]="sortDefinitions"
    [selectedValue]="selectedItem"
    [displayValueSelector]="displayValueSelector"
    [overlayPanelClass]="'sort-dropdown-overlay'"
    (select)="selectSort($event)"
  ></app-dropdown-control>
}
